import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { getLocalizedValue } from '@grandvisionhq/utils';
import { useAttributes } from './hooks/use-attributes.js';
import { useFetchBundle } from './hooks/use-fetch-bundle.js';
import { convertAttributesToLineItems } from './utils.js';

const LensBundleContext = /*#__PURE__*/ React.createContext(null);
const LensBundleProvider = ({ subscriptionProductSKU , children ,  })=>{
    const data = useFetchBundle(subscriptionProductSKU);
    const { locale  } = useIntl();
    const bundle = data && data.results[0];
    const solutions = data && data.solutions;
    // Bridge between current lenses logic and bundle logic
    const [attributesState, attributeActions] = useAttributes();
    // When the solution changes, the requested sku is updated
    const [bundleSku, setBundleSku] = React.useState('');
    // This sets the initial selected sku
    React.useEffect(()=>{
        if (bundle === null || bundle === void 0 ? void 0 : bundle.masterVariant.sku) {
            setBundleSku(bundle === null || bundle === void 0 ? void 0 : bundle.masterVariant.sku);
        } else {
            console.error('LensBundleProvider: Missing contact lens bundle product');
        }
    }, [
        bundle
    ]);
    const solution1 = React.useMemo(()=>{
        return solutions === null || solutions === void 0 ? void 0 : solutions.find((solution)=>solution.bundleSku === bundleSku
        );
    }, [
        bundleSku,
        solutions
    ]);
    // Based on the selected solution a price is calculated for each month
    const pricePerMonth = React.useMemo(()=>{
        return solution1 && solution1.bundlePrice[0].value;
    }, [
        solution1
    ]);
    const lensSku = React.useMemo(()=>{
        if (bundle) {
            var ref, ref1, ref2, ref3;
            const productReference = (ref1 = (ref = bundle.masterVariant.attributes) === null || ref === void 0 ? void 0 : ref.find((attribute)=>attribute.name === 'bundleProduct1'
            )) === null || ref1 === void 0 ? void 0 : ref1.value;
            const lensMasterData = productReference === null || productReference === void 0 ? void 0 : (ref2 = productReference.obj) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.masterData) === null || ref3 === void 0 ? void 0 : ref3.current;
            const sku = lensMasterData === null || lensMasterData === void 0 ? void 0 : lensMasterData.masterVariant.sku;
            return sku;
        }
    }, [
        bundle
    ]);
    const lineItems = React.useMemo(()=>{
        return convertAttributesToLineItems({
            bundleSku,
            name: (bundle === null || bundle === void 0 ? void 0 : bundle.name) ? getLocalizedValue(bundle === null || bundle === void 0 ? void 0 : bundle.name, locale) : '',
            sku: lensSku,
            attributesState,
            solutionName: (solution1 === null || solution1 === void 0 ? void 0 : solution1.name) ? getLocalizedValue(solution1 === null || solution1 === void 0 ? void 0 : solution1.name, locale) : undefined,
            solutionSku: solution1 === null || solution1 === void 0 ? void 0 : solution1.sku
        });
    }, [
        bundleSku,
        bundle,
        lensSku,
        attributesState,
        solution1,
        locale
    ]);
    const context = React.useMemo(()=>{
        return {
            bundleSku,
            pricePerMonth,
            attributes: {
                state: attributesState,
                actions: attributeActions
            },
            lineItems,
            solutions: {
                onSolutionChange: (sku, onChanged)=>{
                    setBundleSku(sku);
                    onChanged && onChanged();
                },
                activeSolution: solution1,
                items: (data === null || data === void 0 ? void 0 : data.solutions) || []
            }
        };
    }, [
        attributesState,
        lineItems,
        bundle,
        bundleSku
    ]);
    return /*#__PURE__*/ React.createElement(LensBundleContext.Provider, {
        value: context
    }, children);
};
const useLensBundle = ()=>{
    const context = React.useContext(LensBundleContext);
    if (context === null) {
        throw new Error('Missing contact lens bundle provider. Make sure the page is wrapped with the LensBundleProvider');
    }
    return context;
};

export { LensBundleContext, LensBundleProvider, useLensBundle };
//# sourceMappingURL=context.js.map
